import * as React from 'react';
import { status } from '../constants';
import {abbreviationName} from '../../../../common/util';
import UserImage from '../../../../components/UserImage/index';

export default class TerminateB2BTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.renderTemplate = this.renderTemplate.bind(this);
    }

    renderTemplate(data, type) {
        switch (type) {
            case "Contract":
                return (
                    <React.Fragment >
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            <a href={data.B2BUrl} title={data.ContractNameFull}>{data.ContractName}</a> with <a href="javascript:void(0);" className="org-tooltip" orgId={data.B2BOrgId} onClick={(e)=>this.props.extraData.onProfileClick(e,data.B2BOrgId,'org')}>{data.B2BOrganisationName}</a> has been terminated
                        </span>
                    </React.Fragment>
                );
            case "ContractSender":
                return (
                    <React.Fragment >
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            <a href={data.B2BUrl} title={data.ContractNameFull}>{data.ContractName}</a> with <a href="javascript:void(0);" className="org-tooltip" orgId={data.B2BOrgId} onClick={(e)=>this.props.extraData.onProfileClick(e,data.B2BOrgId,'org')}>{data.B2BOrganisationName}</a> has been terminated
                        </span>
                    </React.Fragment>
                );
        }
    }

    render() {
        const {extraData}=this.props;
        return (
            <div className={extraData.displayMarkReadIcon ? (`card ${extraData.IsGroupByEnabled  && !extraData.showGroupedNotificationDetail ? 'cardGroup' :'cardPlain'} ${this.props.data.Status == status.read ? 'cardGroupRead' : ''}`):''} onClick={()=>{(extraData.IsGroupByEnabled && !extraData.showGroupedNotificationDetail) ? this.props.handleCardClick(this.props.data) :false}}>
                {
                    extraData.displayMarkReadIcon && 
                    <React.Fragment>
                        {
                            <span className="posRight quickTooltip-bottom" data-quicktooltip={this.props.data.Status == status.read ? "mark as unread": "mark as read"} 
                            onClick={(e)=>{
                                e.stopPropagation();
                                        if(this.props.data.Status == status.read)
                                            extraData.handleMarkRead(this.props.data,status.unRead)
                                        else
                                            extraData.handleMarkRead(this.props.data,status.read)
                                        }}>
                                <em className={`read ${this.props.data.Status == status.read ? "unread":""}`}></em>
                            </span>
                        }
                        {extraData.IsGroupByEnabled && !extraData.showGroupedNotificationDetail?<div className="rwoFlex alignMiddle wkNumber">
                            <label className="badges wkSymbol mr__1">{this.props.data.WorkkardId?'W':'0'}</label> {this.props.data.WorkkardNo?this.props.data.WorkkardNo:'Others'}
                            {
                                extraData.IsGroupByEnabled && extraData.GroupNotificationCounter > 0 && <label className="newCard ml__1">{extraData.GroupNotificationCounter > 99 ? '99+' : extraData.GroupNotificationCounter} new{extraData.RecentWorkkardCountRecieved && <span className="newCardNotification"></span>}</label>
                            }
                        </div> : this.props.data.AllNotificationCount > 0 ? <div className="rwoFlex alignMiddle"><label className="newCard">new</label></div> : null} 
                    </React.Fragment>
                }
                <div className={extraData.displayProfilePic ? "rowFlex mt activity_desc":"rowFlex activity_desc"}>
                    {
                        extraData.displayProfilePic && 
                        <div className="badges badgesSmall mr">
                            <UserImage profileUrl={this.props.data.TriggeredByProfileImage} size="22" className="profilePic" profileName={this.props.data.TriggeredByFullName} /> 
                                                 
                        </div>
                    }
                    <div className={extraData.displayProfilePic ?"":"notificationDate"}>  
                        {
                            extraData.displayTriggerByName && 
                            <>
                                <span className="userName flexGrow" onClick={(e)=>extraData.onProfileClick(e,this.props.data.TriggeredById,'user')}>{this.props.data.TriggeredByFullName}</span>
                                {extraData.showGroupedNotificationDetail && <label>{abbreviationName(this.props.data.TriggeredByOrganisationNameFull)}</label>}
                            </>
                        }                                
                        {this.renderTemplate(this.props.data, this.props.type)}
                        <label className={extraData.displayProfilePic ? "notification__time" : "notification__time gray"}>{extraData.displayProfilePic ? this.props.data.CreatedDate.split("at")[1] : this.props.data.CreatedDate}</label>
                    </div>
                </div>
            </div>
        );
    }
}